import { Text } from '../design-system';
import styled from 'styled-components';

const PreLineText = styled(Text)`
  white-space: pre-line;
`;

export default PreLineText;
